import React, { useState, useEffect } from 'react';
import {
    Box,
    HStack,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Flex,
} from '@chakra-ui/react'

import { fetchWrapper } from '../../../helpers';
import CustomModal from '../../../components/CustomModal';
import PageLoader from '../../../components/Loader/PageLoader';
import CurrencyCreate from './CurrencyCreate';

function CurrencyList() {
    const [isOpenEdit, setIsOpenEdit] = useState(false)
    const [edit, setEdit] = useState(false)
    const [data, setData] = useState({})
    const [list, setList] = useState([])
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        loadList();
    }, [])

    const loadList = async () => {
        setLoading(true)
        const url = `${process.env.REACT_APP_API_URL}/currency/list`;
        const data = await fetchWrapper.get(url)

        setList(data.data);
        setLoading(false)
    }

    const meCloseEdit = () => {
        setIsOpenEdit(false);
        setEdit(false);
        setData({});
    }
    const meopen = () => {
        setIsOpenEdit(true);
        setEdit(false);
        setData({});
    }
    const handleOpenEdit = (rs) => {
        setIsOpenEdit(true);
        setEdit(true);
        setData(rs);
    }


    return (
        <>

            <PageLoader isLoading={loading} />

            <div className="setting_detail_section">
                <HStack justifyContent="space-between">
                    <Box style={{ width: "100%" }}>
                        <Flex justifyContent="space-between">
                            <h2 className="main_heading">Currency</h2>
                            <CustomModal
                                showModalButtonText="Add New Currency"
                                modalHeader="Add New Currency"
                                isOpen={isOpenEdit}
                                onClose={meCloseEdit}
                                onOpen={meopen}
                                modalBody={<CurrencyCreate loadList={loadList} isOpenEdit={isOpenEdit} meCloseEdit={meCloseEdit} edit={edit} data={data}/>}
                            />
                        </Flex>
                    </Box>

                </HStack>
                <div className="table_section">
                    <TableContainer width="100%">
                        <Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
                            <Thead >
                                <Tr>
                                    <Th>Currency Name</Th>
                                    <Th>Code</Th>
                                    <Th>Conversion rate</Th>
                                    <Th></Th>
                                </Tr>
                            </Thead>

                            <Tbody fontSize="14px">
                                {list.map((rs, index) => {
                                    return (
                                        <Tr key={rs?.id}>
                                            <Td style={{ color: "#0000EE", cursor: "pointer" }} onClick={()=>handleOpenEdit(rs)}>{rs.name}</Td>
                                            <Td>{rs?.code}</Td>
                                            <Td>{rs?.conversion_rate}</Td>

                                        </Tr>

                                    )
                                })}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </>
    )
}


export default CurrencyList
